import SimpleImageSlider from "react-simple-image-slider";
import Carousel from "react-bootstrap/Carousel";
import React from "react";
import Loader from "./Loader";

class ImageSlider extends React.Component {
    state = {
        images: [],
    };

    componentWillMount = () => {
        this.setState({
            images: this.props.images,
        });
    };

    render() {
        return (
            <div>
                <Carousel>
                    {this.state.images.map((index, key) => {
                        return (
                            <Carousel.Item key={key}>
                                <img
                                    className="d-block w-100"
                                    src={index}
                                    alt="slider image"
                                    style={{
                                        width: "100%",
                                        height: "400px",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "100% 100%",
                                    }}
                                />
                            </Carousel.Item>
                        );
                    })}
                </Carousel>
                <hr />
            </div>
        );
    }
}

export default ImageSlider;
